import { useMemo } from 'react';
import { useFetchOutOfOfficeStatusesQuery } from '../../__generated__/chirp/com/hubspot/cv/assignments/rpc/OutOfOfficeHoursRpc.hooks';
import { captureException } from '../utils/sentryUtils';
const EMPTY_STATUSES = {};
export const useOutOfOfficeStatuses = userIds => {
  var _data$statuses;
  // The query is cached per exact variables, so equal id sets must be ordered
  // identically for the sidebar and builders to share one response.
  const sortedUserIds = useMemo(() => Array.from(new Set(userIds)).sort((a, b) => a - b), [userIds]);
  const {
    data
  } = useFetchOutOfOfficeStatusesQuery({
    variables: {
      userIds: sortedUserIds
    },
    skip: sortedUserIds.length === 0,
    onError: err => {
      captureException(err, {
        extra: {
          fingerprint: 'useOutOfOfficeStatuses-fetch'
        }
      });
    }
  });
  return (_data$statuses = data === null || data === void 0 ? void 0 : data.statuses) !== null && _data$statuses !== void 0 ? _data$statuses : EMPTY_STATUSES;
};